// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from 'firebase/firestore'
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuQUKmbj0hmyfCGdbKt2hb0N7cDA6F07M",
  authDomain: "disney-clone-a1.firebaseapp.com",
  projectId: "disney-clone-a1",
  storageBucket: "disney-clone-a1.appspot.com",
  messagingSenderId: "1095329215050",
  appId: "1:1095329215050:web:5da015f4a5f4de2a6cacb3",
  measurementId: "G-79C3T4NWYC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const auth = getAuth(app);
const db = getDatabase(app);
const db1=getFirestore(app);
const provider = new GoogleAuthProvider();
auth.languageCode = 'it';


export { auth, provider, storage ,db1,analytics};
export default db;